import { updateIncidentAnsweredUseCase } from '@src/main/modules/other_incidents/application/use-cases/update/update-incident-answered.usecase';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateIncidentAnswered = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  return useMutation({
    mutationFn: async ({
      id,
      idAnswered,
      fullNameAnswered,
      dateAnswered,
    }: {
      id: string;
      idAnswered: string;
      fullNameAnswered: string;
      dateAnswered: string;
    }) =>
      await updateIncidentAnsweredUseCase(
        { id, idAnswered, fullNameAnswered, dateAnswered },
        tokenProvider,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['incidents'] });
    },
  });
};
